const url = $('[data-socket-url]').data('socket-url') || false;
const id = $('[data-socket-id]').data('socket-id') || false;
const time = $('[data-socket-time]').data('socket-time') || false;
const hash = $('[data-socket-hash]').data('socket-hash') || false;

if (url && id && time && hash) {
    const socket = new WebSocket(url);

    socket.onopen = () => {
        socket.send(JSON.stringify({
            type:'join',
            id:id,
            time:time,
            hash:hash
        }));
    };

    socket.onmessage = (message) => {
        const payload = JSON.parse(message.data);
        getCount(payload.count || 0);
        getNotifications(payload.html);
    };

    socket.onclose = console.log;
    socket.onerror = console.error;
    window.socket = socket;

    function getCount(count) {
        const $notificationTooltips = $('.js-notifications-tooltip'),
            $notificationDot = $('.js-notification-dot');

        if (parseInt(count) > 0) {
            $notificationTooltips.each(function () {
                $(this).removeAttr('style').text(count);
            });
            $notificationDot.addClass('is-active');
        } else {
            $notificationTooltips.each(function () {
                $(this).css({
                    'display': 'none'
                });
            });
            $notificationDot.removeClass('is-active');
        }
    }

    function getNotifications(html) {
        const $notificationsContainer = $('.notifications').find('.js-notifications-container');

        if ($notificationsContainer.length) {
            $notificationsContainer.prepend(html[window.userLang]);

            if (typeof kaspersky.unreadCount !== 'undefined') {
                ++kaspersky.unreadCount;
            }
        }
    }

}



// WEBPACK FOOTER //
// /resources/components/ws-client/ws-client.js